import { render, staticRenderFns } from "./ReceiveBNB.vue?vue&type=template&id=11908b66&"
import script from "./ReceiveBNB.vue?vue&type=script&lang=js&"
export * from "./ReceiveBNB.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports